/**
 * Created by sagil on 09/10/2016.
 */
import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
	selector: 'cp-warning-popup',
	template: `
	<cp-info-popup [level]="'Warning'" [width]="width" [customLabel]="customLabel" (close)="close.emit($event)" [messagesHeightChanges]="messagesHeightChanges">
			<ng-content select=".popup-text" ngProjectAs=".popup-text"></ng-content>
			<ng-content select=".popup-buttons" ngProjectAs=".popup-buttons"></ng-content>
	</cp-info-popup>`
})
export class WarningPopupComponent {
	@Input() customLabel: string;
	@Input() width: number;
	@Input() messagesHeightChanges: boolean;
	@Output() close = new EventEmitter();
}
